export default "__VITE_ASSET__B35DOsfP__"